export default function OutboundReferralsIcon({ width = 16, height = 16, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.00009 0C1.55244 0 2.00018 0.44776 2.00018 1.00009V8.00071C2.00018 8.55306 1.55244 9.0008 1.00009 9.0008C0.44774 9.0008 0 8.55306 0 8.00071V1.00009C0 0.44776 0.44774 0 1.00009 0Z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.70671 5.8715H4.95629C4.26587 5.8715 3.70618 5.31181 3.70618 4.62138C3.70618 3.93097 4.26587 3.37127 4.95629 3.37127H9.70671V1.3282C9.70671 0.882701 10.2453 0.659601 10.5603 0.974609L13.8535 4.2678C14.0488 4.46308 14.0488 4.77969 13.8535 4.97497L10.5603 8.26811C10.2453 8.58314 9.70671 8.36002 9.70671 7.91458V5.8715Z'
      />
    </svg>
  );
}
